import { cssVariableName, inkOn, type FillInk } from '@bms2/shared';

/** The two text tokens a filled row chooses between (decision 1290). */
export const FILL_INK_TOKEN: Readonly<Record<FillInk, string>> = {
  light: 'var(--on-level-fill)',
  dark: 'var(--text)',
};

/**
 * A token expression's value as the page's stylesheet resolves it, or null
 * where it resolves to nothing: an expression that is not a token, or a page
 * with no stylesheet loaded, which is every screen test.
 */
export function resolvedToken(expression: string, root: Element | null = typeof document === 'undefined' ? null : document.documentElement): string | null {
  const name = cssVariableName(expression);
  if (!name || !root || typeof getComputedStyle !== 'function') return null;
  const value = getComputedStyle(root).getPropertyValue(name).trim();
  return value === '' ? null : value;
}

/**
 * 🔒 The ink a row filled with `fill` takes (decision 1290), computed from the
 * three tokens' resolved values at render. 🔨 Where the stylesheet has not
 * resolved them the answer is light, because each of the four level colours is
 * a dark hex chosen to clear 4.5:1 against a white ground, and the token test
 * holds that of the file itself.
 */
export function fillInkFor(fill: string, root?: Element | null): FillInk {
  return inkOn(resolvedToken(fill, root), resolvedToken(FILL_INK_TOKEN.light, root), resolvedToken(FILL_INK_TOKEN.dark, root)) ?? 'light';
}
